import { openAsana } from "../../features/external";
import { createExternalDispatchPage } from "../../features/external/components/ExternalDispatch";
import { linkAccount } from "../../features/payout/actions";

export const ExternalDispatchPage = createExternalDispatchPage({
  asana: {
    action: openAsana.started,
  },
  account: {
    action: linkAccount.started,
  },
  mcpay: {
    action: linkAccount.started,
  },
});
